module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THERE’S SOMETHING ABOUT ST. TROPEZ")]), _vm._v(". Copyright © 2009 by Ardnavarna, Inc. All rights reserved. Printed in the United States of America. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "href": "http://www.stmartins.com",
      "target": "_blank"
    }
  }, [_vm._v("www.stmartins.com")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Design by Sarah Gubkin")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LIBRARY OF CONGRESS CATALOGING-IN-PUBLICATION DATA")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Adler, Elizabeth (Elizabeth A.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There’s something about St. Tropez / Elizabeth Adler. — 1st ed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("        p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("ISBN 13: 978-0-312-38514-9")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("ISBN 10: 0-312-38514-5")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("1. Private investigators—Fiction. 2. Television actors and actresses—Fiction. 3. Saint-Tropez (France)—Fiction. 4. Vacation rentals—Fiction. 5. Villas—Fiction. 6. Strangers—Fiction. 7. Murder—Investigation—Fiction. I. Title. II. Title: There’s something about Saint-Tropez.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("PR6051.D56T48 2009")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("823'.914—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("2009007676")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("First Edition: July 2009")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("10  9  8  7  6  5  4  3  2  1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8422d616","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 66
// module chunks = 0